const sections = {
  dashboard: 'dashboard',
  'company/basic': 'company-basic',
  'company/market': 'company-market',
  materials: 'materials',
  personas: 'personas',
  'user-apps': 'user-apps',
  'daily-tasks': 'daily-tasks',
}

export function projectRoute(section, projectId) {
  if (!Object.hasOwn(sections, section) || !projectId) return null
  return { name: `project-manager-${sections[section]}`, params: { projectId } }
}

export function legacyProjectRoute(to, assignment, fallback) {
  if (assignment?.state !== 'assigned') return fallback
  const section = to.path.replace(/^\/workspace\/?/, '') || 'dashboard'
  const target = projectRoute(section, assignment.project?.id)
  return target ? { ...target, query: to.query, hash: to.hash } : fallback
}
